<div class="right-side-bar Rightsection right-expend" id="Rightsection-id" (window:resize)="onResize()"
  (window:onload)="onResize()">
  <div class="Instrument-Chart-container-main">
    <div class="main-dashboard mt-5">
      <div class="col-lg-12 p-0 dash-head">
        <div class="heading-back-data-continer">
          <h4 class="right-sidebar-heading">
            <span class="backbtn-data"> </span>Load Chart Report
          </h4>
        </div>
        <div class="col-lg-3">
          <mat-form-field class="global-search-input" style="display: block" appearance="outline">
            <input class="search-input" placeholder="Search" matInput [formControl]="searchControl" />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3 bar-data1">
    <form [formGroup]="loadChartForm" id="loadChartForm">
      <div class="width100 input_label">
        <div class="margin-right-5 width15">
          <div class="fxg-field fxg-field2">
            <mat-form-field style="display: block">
              <mat-select formControlName="SiteId" (selectionChange)="OnChangeSite($event)">
                <mat-option value="">(Select Customer)</mat-option>
                <mat-option MatFormFieldControl="SiteId" *ngFor="let lstsite of SiteList" [value]="lstsite.CodeValue">
                  {{ lstsite.CodeDisplayText }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="error_msg" *ngIf="displayMessage.SiteId">
              {{ displayMessage["SiteId"] }}
            </div>
          </div>
        </div>
        <div class="margin-right-5 width15">
          <div class="fxg-field fxg-field2">
            <mat-form-field style="display: block">
              <mat-form-field style="display: block" title="Panel Name">
                <mat-select formControlName="PanelId" (selectionChange)="OnChangePanel($event)">
                  <mat-option value="">(Select Location)</mat-option>
                  <mat-option MatFormFieldControl="PanelId" *ngFor="let lstpanel of PanelList"
                    [value]="lstpanel.CodeValue">
                    {{ lstpanel.CodeDisplayText }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-form-field>
            <div class="error_msg" *ngIf="displayMessage.PanelId">
              {{ displayMessage["PanelId"] }}
            </div>
          </div>
        </div>
        <div class="margin-right-5 width15">
          <div class="fxg-field fxg-field2">
            <mat-form-field style="display: block">
              <mat-select formControlName="DeviceId" (selectionChange)="OnChangeDeviceId($event)">
                <mat-option value="">(Select Meter)</mat-option>
                <mat-option MatFormFieldControl="DeviceId" *ngFor="let lstdevice of DeviceList"
                  [value]="lstdevice.CodeValue">
                  {{ lstdevice.CodeDisplayText }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="error_msg" *ngIf="displayMessage.DeviceId">
              {{ displayMessage["DeviceId"] }}
            </div>
          </div>
        </div>
        <div class="margin-right-5 width15">
          <div class="fxg-field fxg-field2">
            <mat-form-field style="display: block">
              <mat-select formControlName="DataType" (selectionChange)="OnChangeDataType($event)">
                <mat-option value="">(Select Data Type)</mat-option>
                <mat-option value="BatchData">Batch Data</mat-option>
                <mat-option value="RawData">Raw Data</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="error_msg" *ngIf="displayMessage.DataType">
              {{ displayMessage["DataType"] }}
            </div>
          </div>
        </div>
        <mat-form-field style="width: 18%" class="calendar margin-right-5">
          <input formControlName="FormStartDate" id="FormStartDate" name="FormStartDate" matInput #ref
            [matDatepicker]="picker1" placeholder="From Date" [maxlength]="8" />
          <mat-datepicker-toggle matSuffix [for]="picker1" class="date-ic-flow-graph">
          </mat-datepicker-toggle>
          <mat-datepicker #picker1 class="picker112" id="pickermat"></mat-datepicker>
        </mat-form-field>
        <mat-form-field style="width: 18%" class="calendar margin-right-5">
          <input formControlName="FormEndDate" id="FormEndDate" name="FormEndDate" matInput #ref [maxlength]="8"
            [matDatepicker]="picker2" placeholder="To Date" />
          <mat-datepicker-toggle matSuffix [for]="picker2" class="date-ic-flow-graph">
          </mat-datepicker-toggle>
          <mat-datepicker #picker2 class="picker112" id="pickermat"></mat-datepicker>
        </mat-form-field>

        <mat-form-field style="width: 16%" class="timepicker margin-right-5" appearance="fill">
          <mat-label>From Time</mat-label>
          <input matTimepicker #fromTimePicker="matTimepicker" [strict]="false" mode="24h" formControlName="FromTime"
            placeholder="00:00" name="FromTime" />
        </mat-form-field>

        <mat-form-field style="width: 16%" class="timepicker margin-right-5" appearance="fill">
          <mat-label>To Time</mat-label>
          <input matTimepicker #toTimePicker="matTimepicker" [strict]="false" mode="24h" formControlName="ToTime"
            placeholder="23:59" name="ToTime" />
        </mat-form-field>

        <div class="width5 input_label">
          <div class="width5 input_label">
            <a type="submit" class="margin-right-5" title="Search" (click)="this.getLoadChartList()">
              <img class="backbtnimg" id="backbtnimg1" src="../assets/images/search_blue.svg"
                style="width: 17px; height: 16px; margin-top: 3px" />
            </a>
            <a class="margin-right-5" title="Export to Excel" (click)="onExport()">
              <img class="backbtnimg" id="backbtnimg1" src="../assets/images/export_orange.svg"
                style="width: 20px; height: 20px; cursor: pointer" />
            </a>
            <a class="margin-right-5" title="Schedule Report" (click)="onScheduleReport()">
              <img class="backbtnimg" id="backbtnimg1" src="../assets/images/Schedule Report.svg"
                style="width: 20px; height: 20px; cursor: pointer" />
            </a>
          </div>
        </div>
      </div>
      <span class="errmsg">{{ totalconsumptionError }}</span>
      <div class="main-sucessmsg">
        {{ totalconsumptionsuccess }}
      </div>

      <div class="table-responsive mat-elevation-z8">
        <div class="table-scroll-report table-scroll-report-width load-chart-table">
          <table mat-table [dataSource]="ReportDetailList" class="mat-elevation-z8 mat-table-bordered" matSort>
            <ng-container *ngFor="let labelObj of labelname_List" [matColumnDef]="labelObj.key">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ labelObj.label }}
              </th>
              <td mat-cell *matCellDef="let row">
                <ng-container *ngIf="labelObj.key === 'Str_RTC'; else normalData">
                  {{ getDate(row["Str_RTC"]) }}
                </ng-container>
                <ng-template #normalData>
                  <ng-container *ngIf="labelObj.key === 'Str_RTC_Time'; else defaultData">
                    {{ getTime(row["Str_RTC"]) }}
                  </ng-container>
                </ng-template>
                <ng-template #defaultData>
                  {{ row[labelObj.key] }}
                </ng-template>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns" class="table-bordered fixedheader"></tr>
            <tr mat-row *matRowDef="let row; columns: columns" class="table-bordered"></tr>
            <tr class="mat-row" *matNoDataRow style="
                text-align: center;
                left: 50;

                position: absolute;
                margin-left: 45%;
                top: 50%;
              ">
              <span class="mat-cell" colspan="{{ labelname_List?.length }}">
                No records found
              </span>
            </tr>
          </table>

          <!-- <div *ngIf="errorMsg" class="paddingtop15 textcenter">
            {{ errorMsg }}
          </div> -->
        </div>
        <div class="sticky-paginator">
          <mat-paginator #paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>
      <!-- <div class="table-responsive mat-elevation-z8">
        <div class="table-scroll-report table-scroll-report-width">
          <div
            *ngIf="totalconsumptionError"
            class="main-errormsg paddingtop15 textcenter"
          >
            {{ totalconsumptionError }}
          </div>
        </div>
      </div> -->
    </form>
  </div>
</div>